import { render, staticRenderFns } from "./AllocationRuleBasedTemplate.vue?vue&type=template&id=d060153e"
import script from "./AllocationRuleBasedTemplate.vue?vue&type=script&lang=js"
export * from "./AllocationRuleBasedTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports